import React from 'react';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import routes from 'src/constants/routes';
import { PublicLayout, BaseLayout, PrivateLayout } from 'src/components/Layout';
import ErrorPlaceholder from 'src/components/ErrorPlaceholder';
import ErrorBoundary from 'src/components/ErrorBoundary';
import AuthorizedRoute from 'src/components/AuthorizedRoute';
import TwoFactorAuthorizedRoute from 'src/components/TwoFactorAuthorizedRoute';
import Root from 'src/Pages/Root';
import Main from 'src/Pages/Main';
import AboutCompany from 'src/Pages/AboutCompany';
import Contacts from 'src/Pages/Contacts';
import Banks from 'src/Pages/Banks';
import BankApplication from 'src/Pages/BankApplication';
import Registration from 'src/Pages/Registration';
import Authorization from 'src/Pages/Authorization';
import PasswordRecovery from 'src/Pages/PasswordRecovery';
import ChangePassword from 'src/Pages/ChangePassword';
import PhoneConfirm from 'src/Pages/PhoneConfirm';
import Agent from 'src/Pages/Agent';
import AccountProfile from 'src/Pages/AccountProfile';
import EmailConfirmation from 'src/Pages/EmailConfirmation';
import AddOrganization from 'src/Pages/AddOrganization';
import AddBank from 'src/Pages/AddBank';
import Merchants from 'src/Pages/Merchants';
import AcceptInvitation from 'src/Pages/AcceptInvitation';
import Help from 'src/Pages/Help';
import Offer from 'src/Pages/Offer';
import Offer_01_08_2023 from 'src/Pages/Offer/oldVersions/01-08-2023';
import PrivacyPolicy from 'src/Pages/PrivacyPolicy';
import CookiePolicy from 'src/Pages/CookiePolicy';
import NotPartnerBanks from 'src/Pages/NotPartnerBanks';
import 'src/themes/bootstrap/index.scss';
import 'src/themes/default/index.scss';
import './styles.module.scss';

const App: React.FC = () => {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path={routes.root} element={<Root />} />
          <Route element={<PublicLayout />}>
            <Route path={routes.main} element={<Main />} />
            <Route path={routes.about} element={<AboutCompany />} />
            <Route path={routes.contacts} element={<Contacts />} />
            <Route path={routes.banks} element={<Banks />} />
            <Route path={routes.bankApplication} element={<BankApplication />} />
            <Route path={routes.notPartnerBanks} element={<NotPartnerBanks />} />
          </Route>
          <Route element={<BaseLayout />}>
            <Route path={routes.registration} element={<Registration />} />
            <Route path={routes.authorization} element={<Authorization />} />
            <Route path={routes.acceptInvitation} element={<AcceptInvitation />} />
            <Route path={routes.passwordRecovery} element={<PasswordRecovery />} />
            <Route path={routes.emailConfirmation} element={<EmailConfirmation />} />
            <Route path={routes.offer} element={<Offer />} />
            <Route path={routes.offer_01_08_2023} element={<Offer_01_08_2023 />} />
            <Route path={routes.help} element={<Help />} />
            <Route path={routes.privacyPolicy} element={<PrivacyPolicy />} />
            <Route path={routes.cookiePolicy} element={<CookiePolicy />} />
          </Route>
          <Route element={<AuthorizedRoute />}>
            <Route element={<BaseLayout />}>
              <Route path={routes.phoneConfirm} element={<PhoneConfirm />} />
            </Route>
          </Route>
          <Route element={<AuthorizedRoute />}>
            <Route element={<PrivateLayout />}>
              <Route path={routes.agent} element={<Agent />} />
              <Route path={routes.organization} element={<Agent />} />
              <Route path={routes.accountProfile} element={<AccountProfile />} />
              <Route path={routes.merchants} element={<Merchants />} />
            </Route>
          </Route>
          <Route element={<TwoFactorAuthorizedRoute />}>
            <Route element={<PrivateLayout />}>
              <Route path={routes.addOrganization} element={<AddOrganization />} />
              <Route path={routes.addBank} element={<AddBank />} />
              <Route path={routes.changePassword} element={<ChangePassword />} />
            </Route>
          </Route>
          <Route
            path="*"
            element={<ErrorPlaceholder code={404} text="Запрашиваемая страница не найдена." />}
          />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        hideProgressBar
        draggable={false}
        theme="colored"
        icon={false}
        transition={Slide}
        position="bottom-right"
      />
    </ErrorBoundary>
  );
};

export default App;
